import { createContext, useContext } from "react";

export const OnlinePreviewContext = createContext(false);
export const useOnlinePreview = () => useContext(OnlinePreviewContext);
